export default "__VITE_ASSET__jBnk_CX4__"